export default __webpack_public_path__ + "static/media/foton.b833e031.svg";